module.exports = __webpack_public_path__ + "img/logo_thefastmode.aa307319.png";